export const employeeBasicInfoTabInputs = [
  'firstName',
  'lastName',
  'nationalId',
  'contact-phoneNumber',
  'dateOfBirth',
  'nationality',
  'accessType',
  'gender',
  'maritalStatus',
]

export const invalidBankFieldsArray = ['bankName', 'accountNumber']

export const employeeContractInputs = ['value', 'endDate']

export const employeesInitialState = {
  educationLevelType: null,
  contracts: [],
  firstName: '',
  nationality: '',
  dateOfBirth: null,
  lastName: '',
  department: null,
  foodDietaryPreferenceType: null,
  notes: [
    {
      id: new Date().getMilliseconds(),
      content: '',
      visibilityScope: null,
      category: null,
    },
  ],
  nationalId: '',
  shouldSendTemporaryPassword: true,
  role: {
    name: '',
    id: null,
  },
  gender: '',
  maritalStatus: '',
  contact: {
    email: '',
    phoneNumber: '+',
  },
  machines: [],
  operations: [],
  profileImage: false,
  image: '',
  accessType: '',
  isNone: false,
  documentData: {
    category: null,
    accessRestrictions: null,
    effectiveDate: null,
    expiryDate: null,
    version: null,
  },
  bankInfo: {
    id: null,
    ssnit: '',
    bankName: '',
    branchCode: '',
    accountNumber: '',
  },
  logisticsInfo: {
    hasFoodProvided: false,
    foodDietaryPreferenceType: null,
    hasFoodAllowance: false,
    foodAllowanceInCompanyAmount: null,
    foodAllowanceOutCompanyAmount: null,
    foodMealSupplier: null,

    hasAccommodationProvided: false,
    accommodation: null,
    hasAccommodationAllowance: false,
    accomodationAllowanceInCompanyAmount: null,
    accomodationAllowanceOutCompanyAmount: null,
    accomodationTierPolicy: null,

    transportationType: { label: 'No Transport', value: 1 },
    transportationVehicleType: null,
    hasTransportationAllowance: false,
    transportationAllowanceInCompanyAmount: null,
    transportationAllowanceOutCompanyAmount: null,

    hasResponsibilityAllowance: false,
    responsibilityAllowanceInCompanyAmount: null,
    responsibilityAllowanceOutCompanyAmount: null,

    hasExtraDutyAllowance: false,
    extraDutyAllowanceInCompanyAmount: null,
    extraDutyAllowanceOutCompanyAmount: null,
  },
  emergencyContact: {
    type: null,
    phoneNumber: '',
    firstName: '',
    lastName: '',
  },
}

export const contractTypes = [
  {
    label: 'Salary',
    value: 1,
  },
  {
    label: 'Hourly',
    value: 2,
  },
  {
    label: 'Daily',
    value: 3,
  },
]
// Monday = 1, Tuesday = 2, Wednesday = 3, Thursday = 4, Friday = 5, Saturday = 6, Sunday = 7

export const days = [
  { label: 'Monday', value: 1 },
  { label: 'Tuesday', value: 2 },
  { label: 'Wednesday', value: 3 },
  { label: 'Thursday', value: 4 },
  { label: 'Friday', value: 5 },
  { label: 'Saturday', value: 6 },
  { label: 'Sunday', value: 7 },
]

// Daily = 1, Weekly = 2, Monthly = 3, Manual = 4

export const shiftChangeTypes = [
  { label: 'Daily', value: 1 },
  { label: 'Weekly', value: 2 },
  { label: 'Monthly', value: 3 },
  { label: 'Manual', value: 4 },
]

export const logisticsTransportationTypes = [
  { label: 'No Transport', value: 1 },
  { label: 'Has Transport', value: 2 },
  { label: 'Self Transport', value: 3 },
]

export const emergencyContactOptions = [
  { label: 'Father', value: 1 },
  { label: 'Mother', value: 2 },
  { label: 'Spouse', value: 3 },
  { label: 'Son', value: 4 },
  { label: 'Daughter', value: 5 },
  { label: 'Brother', value: 6 },
  { label: 'Sister', value: 7 },
  { label: 'Uncle', value: 8 },
  { label: 'Other', value: 9 },
]

// Basic = 1, Secondary = 2, Tertiary = 3

export const educationLevelOptions = [
  { label: 'Basic', value: 1 },
  { label: 'Secondary', value: 2 },
  { label: 'Tertiary', value: 3 },
]

export const transportationVehicleTypes = [
  { label: 'Car', value: 1 },
  { label: 'Bus', value: 2 },
  { label: 'Both', value: 3 },
]
